export default "__VITE_PUBLIC_ASSET__50977ad2__"